export const pick = <ObjType extends Record<string, unknown>, KeyType extends string>(obj: ObjType, keys: readonly KeyType[]) => {
  return keys.reduce((acc, key) => (
    key in obj
      ? { ...acc, [key]: obj[key] }
      : acc
  ), {}) as Pick<ObjType, Exclude<keyof ObjType, Exclude<keyof ObjType, KeyType>>>;
};
